export default __webpack_public_path__ + "static/media/success_plate.9686533a.svg";